import { Component, OnInit, NgZone } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Params,
  NavigationExtras,
} from '@angular/router';

import * as $ from 'jquery';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

const _ = require('underscore');

declare var google: any;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit {
  allClinics = [];
  areaClinics = [];
  clinicsToShow = [];
  unfilteredClinics = [];
  externalClinic: string;
  selectedClinics = [];
  selectedClinicOverlay = { _id: '' };
  isSelectedClinicOverlay: boolean;
  mapMarkerIcon = 'assets/images/pin_map.svg';
  search = 'assets/icons/search-green.svg';
  mapMarkerIconSelected = 'assets/images/pin_map_selected.svg';
  googleMaps: any;
  oldMapMarker: any;
  isExternal: boolean;
  active_step: string;
  fisiqClinics: boolean;
  fisiqService: string;
  flowType: string;
  superClinicId: string;
  clinics: string;
  singleClinic: string;
  lanCenter: string;
  latCenter: string;
  aalborgFlow: boolean;
  bounds: any;
  currentUser: any = this.helper.getStorage("currentUser");
  readonly flowName: any = Constants.FLOW_TYPE;
  readonly steps: any = Constants.STEPS;

  API = this.helper.getApi();
  url = this.helper.getDomain();

  constructor(
    private _ngZone: NgZone,
    private route: ActivatedRoute,
    public helper: Helper,
    private router: Router
  ) {}

  ngOnInit() {
    const storage_clinics = this.helper.getStorage("allClinics");
    
    localStorage.removeItem('bodyParts');

    this.route.queryParams.subscribe((params: Params) => {
      const externalClinic = params.externalClinic;

      if (externalClinic) this.isExternal = true;
      else this.isExternal = false;

      this.externalClinic = externalClinic;

      if (externalClinic === 1) {
        this.externalClinic =
          '00000a00ca10000007d104000000016156990d7e4359a6bc';
      }

      this.flowType = params.type;

      if (params.type === 'fysiq' || params.type === this.flowName.aalborg) {
        this.fisiqClinics = true;
      }

      if (params.type === this.flowName.aalborg) {
        this.aalborgFlow = true;
      } else {
        this.aalborgFlow = false;
      }

      this.superClinicId = params.superClinicId;
      this.clinics = params.clinics;
      this.singleClinic = params.singleClinic;

      // if single clinic flow - redirect to specify step
      if (this.singleClinic === 'true') {
        this.navigateToSpecify(params.clinics, params.type, this.fisiqService);
      }
    });

    this.active_step = this.steps.map;

    const clinics = storage_clinics;
    const map = this.addMap();

    this.clinicsToShow = clinics.filter((el) => el.is_super_clinic === false);
    
    // if not fysiq flow, filter clinics
    if (this.flowType !== 'fysiq') {

      if (this.fisiqClinics) {
        this.allClinics = this.allClinics.filter((el) => {

          if (el.name.indexOf('FYSIQ') !== -1) {
            return true;
          } else {
            return false;
          }
        });
      }

      if (this.flowType === this.flowName.aalborg) {
        this.clinicsToShow = clinics.filter(
          (el) =>
            el.super_clinic_id ===
            '00000a00ca09000007dc4a000000016f2287ebff6c644d85'
        );
      }
    }

    this.googleMaps = map;

    document.getElementById('loading').style.display = 'none';

    // First show clinic that selected in registration
    // if (storage_clinics) {
    // 	let user_clinic_id = this.currentUser.data.clinicId;

    // 	if (user_clinic_id) {
    // 		self.clinicsToShow = _.sortBy(self.clinicsToShow, function(clinic) {
    // 			return clinic.id === user_clinic_id ? 0 : 1;
    // 		  });
    // 	}
    // }

    this.clinicsToShow = clinics.filter((el) => el.fbooking_flow == 1 && el.general_flow == 1
    );

    // Show super clinic clinics
    if (this.superClinicId && storage_clinics) {
      this.clinicsToShow = storage_clinics.filter(
        (clinic) => clinic.super_clinic_id === this.superClinicId && clinic.fbooking_flow == 1
      );
    }

    // Hide "FysioDanmark Aalborg" clinic if aalborg flow
    if (this.flowType === this.flowName.aalborg) {
      this.clinicsToShow = this.clinicsToShow.filter(
        (el) => el.id !== '00000a00ca09000007d1120700000163248870d75296ee49'
      );
    }
  

    // Sort all clinics by post code
    this.clinicsToShow = _.sortBy(this.clinicsToShow, 'post_code');

    if (this.googleMaps) {
      this.addMapListeners(this.googleMaps, this.clinicsToShow);
    }

    if (
      _.isObject(this.currentUser) &&
      _.isObject(this.currentUser.lastBooking)
    ) {
      this.selectedClinics = _.union(this.selectedClinics, [
        {
          _id: this.currentUser.lastBooking.clinicId,
          value: this.currentUser.lastBooking.clinicName,
        },
      ]);
    }

    this.isSelectedClinicOverlay = false;
    this.unfilteredClinics = this.clinicsToShow;
  }

  initBounds() {
    this.bounds = new google.maps.LatLngBounds();
  }

  addMap() {
    let latlong = this.superClinicId
      ? new google.maps.LatLng(55.674777, 10.726948)
      : new google.maps.LatLng(55.62311, 12.60495);

    if (this.flowType === this.flowName.aalborg) {
      latlong = new google.maps.LatLng(57.0488, 9.9217);
    }

    const mapProp = {
      center: latlong,
      zoom: this.superClinicId ? 7 : 10,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      draggable: true,
      streetViewControl: true,
      rotateControl: false,
      fullscreenControl: true,
      styles: [
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#b7b7b7' }, { lightness: 17 }],
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [{ color: '#d9d9d9' }, { lightness: 20 }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [{ color: '#ffffff' }, { lightness: 17 }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }, { lightness: 18 }],
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }, { lightness: 16 }],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#f5f5f5' }, { lightness: 21 }],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#dedede' }, { lightness: 21 }],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            { visibility: 'on' },
            { color: '#ffffff' },
            { lightness: 16 },
          ],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            { saturation: 36 },
            { color: '#333333' },
            { lightness: 40 },
          ],
        },
        { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ color: '#f2f2f2' }, { lightness: 19 }],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.fill',
          stylers: [{ color: '#fefefe' }, { lightness: 20 }],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }],
        },
      ],
    };

    const map = new google.maps.Map(document.getElementById('map'), mapProp);

    this.initBounds();

    return map;
  }

  addMapListeners(map, clinics) {
    const iniMarkers = this.initializeMarkers(map, clinics);

    map.fitBounds(this.bounds);
    map.panToBounds(this.bounds);

    const self = this;

    map.addListener('bounds_changed', function () {
      self.areaClinics = [];

      _.each(iniMarkers, function (iniMarker) {
		  
        if (map.getBounds().contains(iniMarker.getPosition())) {
          self.areaClinics.push(iniMarker);
        }
      });

      self.areaClinics.push(self.areaClinics);

      self.refreshFilters();
    });

    const extClinic = clinics.filter((el) => el._id === this.externalClinic),
      extMarker = iniMarkers.filter((el) => el._id === this.externalClinic);

    if (extClinic.length + extMarker.length === 2) {
      this.selectMarker(extClinic[0], extMarker[0]);
    }
  }

  initializeMarkers(map, clinics) {
    const self = this;
    const image = {
      url: this.mapMarkerIcon,
      size: new google.maps.Size(25, 25),
    };
    const shape = { coords: [1, 1, 1, 20, 18, 20, 18, 1], type: 'poly' };

    // Show only clinics with latitude and longitude
    clinics = clinics.filter(
      (clinic) => clinic.latitude !== '' && clinic.longitude !== ''
    );

    const clinicMarkers = _.map(clinics, function (clinic) {
      const clinicMarker = new google.maps.Marker({
        position: new google.maps.LatLng(clinic.latitude, clinic.longitude),
        map: map,
        title: clinic.name,
        _id: clinic._id,
        draggable: false,
        shape: shape,
        zIndex: 4,
        icon: image,
      });

      const loc = new google.maps.LatLng(clinic.latitude, clinic.longitude);

      self.bounds.extend(loc);

      clinicMarker.addListener('click', () => {
        self.selectMarker(clinic, clinicMarker);
      });

      google.maps.event.addListener(clinicMarker, 'touchstart', () => {
        self.selectMarker(clinic, clinicMarker);
      });

      return clinicMarker;
    });

    this.oldMapMarker = clinicMarkers[clinicMarkers.length - 1];

    return clinicMarkers;
  }

  selectMarker(marker: any, markerObject: any) {
    const clinicId = marker._id;

    this.navigateToSpecify(clinicId, 'fysiq', this.fisiqService);

    if (this.selectedClinicOverlay._id !== marker._id) {
      markerObject.setIcon(this.mapMarkerIconSelected);
      this.oldMapMarker.setIcon(this.mapMarkerIcon);

      this.oldMapMarker = markerObject;
    }

    this.selectedClinicOverlay = marker;
    this.isSelectedClinicOverlay = true;

    const found = _.find(this.selectedClinics, (clinic) => {
      return clinic._id === marker._id;
    });

    if (found) {
      this.selectedClinics = _.reject(this.selectedClinics, function (clinic) {
        $('#' + marker._id).prop('checked', false);
        return clinic._id == marker._id;
      });

      this.refreshFilters();
    } else {
      markerObject.map.panTo(markerObject.getPosition());
      this.selectedClinics = [{ _id: marker._id, value: marker.name }];
      $('#' + marker._id).prop('checked', true);

      this.refreshFilters();
    }
  }

  fetchClinics(id: string) {
    this.isSelectedClinicOverlay = false;

    this.navigateToSpecify(id, 'fysiq', this.fisiqService);
  }

  refreshFilters() {
    this._ngZone.run(() => {});
  }

  navigateToSpecify(clinicId, type, service) {
    const current_user: any = this.helper.getStorage("currentUser");

    if (current_user) {
      const params = {
        type: this.flowType ? this.flowType : type,
        service: service,
      };

      // if superclinic and superclinic + service flow, send params to next page
      if (this.superClinicId) {
        params['superClinicId'] = this.superClinicId;
      }

      // if singleclinic flow, send params to next page
      if (this.singleClinic === 'true') {
        params['singleClinic'] = true;
        params['clinics'] = this.clinics;
      } else {
        params['singleClinic'] = false;
        params['clinics'] = clinicId;
      }

      const navigationExtras: NavigationExtras = {
        queryParams: params,
      };

      // if general flow, go to services
      if (this.flowType === this.flowName.aalborg) {
        this.router.navigate(['/body-parts'], navigationExtras);
      } else {
        this.router.navigate(['/offer-fysiq'], navigationExtras);
      }
    } else {
      const params = {
        clinics: clinicId,
      };

      const navigationExtras: NavigationExtras = {
        queryParams: params,
      };

      this.router.navigate(['/login'], navigationExtras);
    }

    document.querySelector('.booking-steps').scrollIntoView({
      behavior: 'smooth',
    });
  }

  searchClinics(event: any) {
    let value = event.target.value.toLowerCase();

    if(Number.isInteger(parseInt(value, 10))){
      if(value.length == 2){
        value = value+"00";
      }
      if(value.length == 3){
        value = value+"0";
      }
    }
    
    var range = 1000;
    var temp1 = Math.floor(value / 1000) * 1000;
    var temp2 = parseInt(value, 10)+range;

    this.clinicsToShow = _.filter(this.unfilteredClinics, (clinic) => {
      let post_code = clinic.post_code,
        name = clinic.name.toLowerCase();

      return post_code.startsWith(value) || name.includes(value)|| this.between(post_code, temp1, temp2);;
    });
    this.clinicsToShow.sort((clinica, clinicb) => {
      return Math.abs(clinica.post_code-value) - Math.abs(clinicb.post_code-value);
    });
    
  }

  between(x, min, max) {
          return x >= min && x <= max;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/map/map.component.ts